import { call, put } from 'redux-saga/effects'
import AuthActions from 'Redux/AuthRedux'
import ProjectActions from 'Redux/ProjectRedux'
import TeamActions from 'Redux/TeamRedux'
import SelectionActions from 'Redux/SelectionRedux'
import { BuildErrorMsg } from './ApiHelpers'

export function * onProjectsRequest (api, action) {
  const resp = yield call(api.getProjects)
  if (resp.ok) {
    const data = resp.data.map(entity => ({...entity, isSharedProject: true}))
    yield put(ProjectActions.projectsListSuccess(data))
  } else {
    if (resp.status === 401) {
      yield put(AuthActions.logoutRequest());
    } else {
      yield put(ProjectActions.projectsListFailure(BuildErrorMsg(resp)))
    }
  }
}

export function * onCreateProjectRequest (api, action) {
  const resp = yield call(api.createProject, action.createParams)
  if (resp.ok) {
    yield put(ProjectActions.projectsCreateSuccess(resp.data))
    yield put(TeamActions.teamsListRequest())
    yield put(ProjectActions.projectsListRequest())
    yield put(SelectionActions.selectionsSetData('activeProject', resp.data))
  } else {
    yield put(ProjectActions.projectsCreateFailure(BuildErrorMsg(resp)))
  }
}

export function * onUpdateProjectRequest (api, action) {
  const resp = yield call(api.updateProject, action.id, action.updateParams)
  if (resp.ok) {
    yield put(ProjectActions.projectsUpdateSuccess(resp.data))
    yield put(TeamActions.teamsListRequest())
    yield put(ProjectActions.projectsListRequest())
    yield put(SelectionActions.selectionsSetData('activeProject', resp.data))
  } else {
    yield put(ProjectActions.projectsUpdateFailure(BuildErrorMsg(resp)))
  }
}

export function * onDeleteProjectRequest (api, action) {
  const resp = yield call(api.deleteProject, action.id)
  if (resp.ok) {
    yield put(ProjectActions.projectsDeleteSuccess({success: true}))
    yield put(SelectionActions.selectionsSetData(
      'activeProject', { collaborators: [] }))
    yield put(TeamActions.teamsListRequest())
    yield put(ProjectActions.projectsListRequest())
  } else {
    yield put(ProjectActions.projectsDeleteFailure(BuildErrorMsg(resp)))
  }
}



// WEBPACK FOOTER //
// ./src/Sagas/ProjectSagas.js